<template>
  <div class="flex flex-col">
    <div v-if="messages.length === 0">
      <UWelcomeBanner class="mb-[72px]" />
      <UCombobox
        :options="categoriesOptions"
        class="md:max-w-[447px] mx-auto mb-8 md:mb-11"
        @click="handleCategoryChange"
      />
      <ChatTipsCarousel class="mx-auto max-w-[1375px]" />
    </div>

    <!-- Podcast and other Action Buttons -->

    <!--<div class="relative w-full m-auto md:max-w-[600px]" :class="{
        'hidden': !podcastVisible && messages.length > 0,
        'mb-6': messages.length > 0,
        'py-16': messages.length === 0,
      }">
        <Podcast
          class="transition-opacity"
          :class="{ 'opacity-0 pointer-events-none': !podcastVisible }"
        />
        <Transition>
          <div
            v-if="!podcastVisible && messages.length === 0"
            class="
              md:max-w-[447px]
              absolute w-full top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2
              grid mx-auto text-center
            "
            :class="{
              ' grid-cols-3': typeof url !== 'undefined',
              ' grid-cols-2': typeof url === 'undefined',
            }"
          >
            <ULabeledButton v-if="url" @click="handleCreateOverview">
              <template #icon>
                <IconsBulb class="w-8 h-8" />
              </template>
{{ $t('buttons.createOverview') }}
</ULabeledButton>

<ULabeledButton>
  <template #icon>
                <IconsDownload class="w-8 h-8" />
              </template>
  {{ $t('buttons.relatedModels') }}
</ULabeledButton>

<ULabeledButton @click="podcastVisible = true" variant="light-peach">
  <template #icon>
                <IconsAudioPlay class="w-8 h-8" />
              </template>
  {{ $t('buttons.playPodcast') }}
</ULabeledButton>
</div>
</Transition>
</div> -->

    <OverviewLoader v-if="loadOverview" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import UWelcomeBanner from '@/components/ui/UWelcomeBanner.vue'
import ChatTipsCarousel from '@/components/chat/ChatTipsCarousel.vue'
import UCombobox, { UComboboxOption } from '@/components/ui/UCombobox.vue'
import OverviewLoader from '@/components/loaders/OverviewLoader.vue'
import { CategoryIdEnum } from '@/generated/graphql.mia'
import { storeToRefs } from 'pinia'
import { useCategoriesStore } from '@/stores/categoriesStore'
import { useConversationStore } from '@/stores/conversationStore'
import Clarity from '@microsoft/clarity'
/*import { usePodcastsStore } from '@/stores/podcastsStore'
import Podcast from '@/components/audio/Podcast.vue'
import ULabeledButton from '@/components/ui/ULabeledButton.vue'
import { useCustomParams } from '@/composables/useCustomParams'*/

const conversationStore = useConversationStore()
const { messages } = storeToRefs(conversationStore)
const categoriesStore = useCategoriesStore()
const { categoriesTranslations, activeCategory } = storeToRefs(categoriesStore)
/*const { url } = useCustomParams()*/
const loadOverview = ref(false)

/*const podcastsStore = usePodcastsStore()*/
/*const { podcastVisible } = storeToRefs(podcastsStore)*/

const categoriesOptions = computed<UComboboxOption[]>(() =>
  categoriesTranslations.value.map(cat => ({
    value: cat.categoryEnumType,
    displayText: cat.ngChatPromptCategory!,
    selected: cat.categoryEnumType === activeCategory.value,
    disabled: false,
    hidden: false
  }))
)

const handleCategoryChange = (category: string | number) => {
  Clarity.event('selectedPromptCategory')
  Clarity.setTag('categoryId', String(category))

  categoriesOptions.value.forEach(c => {
    c.selected = c.value === category
  })

  activeCategory.value = category as CategoryIdEnum
}

/*const handleCreateOverview = () => {
  loadOverview.value = true
}*/
</script>
